export default function () {
  // ── 1. Discover containers ─────────────────────────────────────────────────
  const containers = document.querySelectorAll(".description-with-video");

  if (containers.length === 0) return;

  // ── 2. Bind play buttons ───────────────────────────────────────────────────
  containers.forEach((container) => {
    const playBtn = container.querySelector(".js-dwv-play");
    const video = container.querySelector(".js-dwv-video");
    const thumb = container.querySelector(".js-dwv-thumb");
    const preview = container.querySelector(".js-dwv-preview"); // may be null

    if (!playBtn || !video) return;

    function onPlay(e) {
      e.preventDefault();

      // Hide the play button
      playBtn.style.display = "none";

      // If a custom preview image is present, fade it out via the CSS class
      if (preview && thumb) {
        thumb.classList.add("is-playing");
      }

      video.controls = true;
      video.play();
    }

    playBtn.addEventListener("click", onPlay);

    playBtn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") onPlay(e);
    });
  });
}
